var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const fetchCharacters = (paginationModel) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`https://rickandmortyapi.com/api/character/?page=${paginationModel}`);
    const data = yield response.json();
    return data;
});
export const fetchCharacterById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`https://rickandmortyapi.com/api/character/${id}`);
    const data = yield response.json();
    return data;
});
